import { axiosSwagger } from "@/axios";

export const state = {
    office: {
        loading: false,
        data: [],
        total: 0,
    },
}


export const getters = {
}


export const mutations = {
    // OFFICE
    officeLoading: (state, loading) => {
        state.office.loading = loading;
    },
    setOfficeData: (state, data) => {
        state.office.data = [...data].sort((a, b) =>
            a.name.toLowerCase().localeCompare(b.name.toLowerCase())
        );
    },
    setOfficeTotal: (state, total) => {
        state.office.total = total;
    },
    addOffice: (state, data) => {
        state.office.data.push(data);
    },
    removeOffice: (state, id) => {
        state.office.data = state.office.data.filter((el) => el.id !== id);
    },
    updateOffice: (state, data) => {
        const index = state.office.data.findIndex((item) => item.id === data.id);

        if (index !== -1) {
            state.office.data[index].officeName = data.officeName;
            state.office.data[index].shortName = data.shortName;
        }
    },
}


export const actions = {
    // OFFICE
    async readOffice({ commit }) {
        commit("officeLoading", true);

        return await axiosSwagger
        .get("/api/Office/All")
        .then((response) => {
            commit("setOfficeData", response.data);
            commit("setOfficeTotal", response.data.length);
            commit("officeLoading", false);

            return response;
        })
        .catch(() => {
            commit("officeLoading", false);
        });
    },
    async readOfficeByCampusId({ commit }, id) {
        commit("officeLoading", true);

        return await axiosSwagger
        .get(`/api/Office/All/Campus/${id}`)
        .then((response) => {
            commit("officeLoading", false);
            return modifyResponse(response);
        })
        .catch(() => {
            commit("officeLoading", false);
        });
    },
    async createOffice({ commit }, data) {
        return await axiosSwagger
        .post("/api/Office/Create", data)
        .then((response) => {
            commit("addOffice", response.data);

            return response;
        });
    },
    async deleteOffice({ commit }, id) {
        return await axiosSwagger.delete(`/api/Office/${id}`).then((response) => {
        commit("removeOffice", id);

        return response;
        });
    },
    async updateOffice({ commit }, data) {
        return await axiosSwagger
        .put(`/api/Office/${data.id}`, data)
        .then((response) => {
            commit("updateOffice", data);

            return response;
        });
    },
    // GET OFFICE UNIT BY ID
    // eslint-disable-next-line no-unused-vars
    async readOfficeById({ commit }, id){
        return await axiosSwagger
        .get(`/api/Office/${id}`)
        .then((response) => {

            return response;
        });
    },
}


const modifyResponse = (response) => {
    let arrayData = response.data;

    if (!arrayData?.length) {
        response.data = [];
        return response;
    }

    if (process.env.VUE_APP_CLIENT === 'ustp') {
        const filterIds = [3244, 3213];
        arrayData = arrayData.filter((e) => !filterIds.includes(e.id));
    }

    response.data = [...arrayData].sort((a, b) =>
        a.name.toLowerCase().localeCompare(b.name.toLowerCase())
    );

    return response;
}

